export default __webpack_public_path__ + "static/facial-treatments-f205076ad56e5d106f62408eca1c300f.jpg";